import { createNgModuleRef, Injectable, Injector, NgModuleRef } from '@angular/core';
import { ICmsClientExtensionModule } from '../../client-extension/icms-client-extension.module';
import { BehaviorSubject } from 'rxjs';
import { ICmsCampaign } from '@icms/plugin/campaigns/resource/campaign/icms-campaign';
import { ICmsDraft } from '@icms/core/resource/draft/icms-draft';
import { ICmsClientAdminLoaderService } from '../admin-loader/icms-client-admin-loader.service';

@Injectable({ providedIn: 'root' })
export class ICmsClientExtensionLoaderService {
    /**
     * Editor module ref
     */
    private extensionModuleRef?: NgModuleRef<ICmsClientExtensionModule>;
    /**
     * If editor is open
     */
    private statusbarVisible = false;

    readonly draft$ = new BehaviorSubject<ICmsDraft | undefined>(undefined);
    readonly campaign$ = new BehaviorSubject<ICmsCampaign | undefined>(undefined);

    /**
     * Dependencies
     */
    constructor(
        private injector: Injector,
        private iCmsClientAdminLoaderService: ICmsClientAdminLoaderService
    ) {
        this.iCmsClientAdminLoaderService.state.subscribe(() => this.updateStatusbar());
        this.draft$.subscribe(() => this.updateStatusbar());
        this.campaign$.subscribe(() => this.updateStatusbar());
    }

    private updateStatusbar() {
        const isCms = this.iCmsClientAdminLoaderService.state.value;
        if (!isCms && (this.campaign$.value || this.draft$.value)) {
            this.showStatusbar();
        } else {
            this.hideStatusbar();
        }
    }

    private async showStatusbar() {
        if (!this.statusbarVisible) {
            this.statusbarVisible = true;
            const module = await this.loadClientExtensionModule();
            if (this.statusbarVisible) {
                module.instance.createStatusbar();
            }
        }
    }

    private async hideStatusbar() {
        if (this.statusbarVisible) {
            this.statusbarVisible = false;
            this.extensionModuleRef?.instance.destroyStatusbar();
        }
    }

    /**
     * Loads editor module
     */
    private async loadClientExtensionModule() {
        const module = await import(
            /* webpackChunkName: "icms-client-extension.aw" */ '../../client-extension/icms-client-extension.module'
        );
        if (!this.extensionModuleRef) {
            this.extensionModuleRef = createNgModuleRef(module.ICmsClientExtensionModule, this.injector);
        }
        return this.extensionModuleRef;
    }
}
